import Trix from 'trix';

window.Trix = Trix;

export default Trix;
